export default {

    GET_USERS_RANKING_REQUEST: state => {
        state.usersRankingLoading = true
    },
    GET_USERS_RANKING_SUCCESS: (state, data) => {
        state.usersRanking = data.results
        state.usersRankingLoading = false
    },
    GET_USERS_RANKING_FAILURE: state => {
        state.usersRankingLoading = false
    },
    SET_USERS_RANKING_FILTERS: (state, filters) => {
        state.usersRankingFilters = filters
    },
    CLEAR_USERS_RANKING_FILTERS: state => {
        state.usersRankingFilters = state.setInitialUsersRankingFilters()
    },
    GET_RANKING_TYPES: (state, data) => {
        state.rankingTypes = data.results
    },
    GET_RANKING_GROUPS: (state, data) => {
        state.rankingGroups = data.results
    },
    CLEAR_RANKING_GROUPS: state => {
        state.rankingGroups = []
    }
}